import React from "react";
import Navigation from "../Navigation";
import UserInfo from "../UserInfo";
import MobileNavigation from "../MobileNavigation";
import { useSelector } from "react-redux";

const HeaderLayout = () => {
  const screen = useSelector((store) => store.userReducer.screen);

  return screen.mobile ? (
    <div className="mob-nav__wrapper">
      <MobileNavigation />
    </div>
  ) : (
    <div className="header">
      <UserInfo />
      <Navigation />
    </div>
  );
};

export default HeaderLayout;
